export enum formType {
  valueFrom = 'valueFrom',
  valueTo = 'valueTo',
}

export enum formTypeOld {
  valueFromOldValue = 'valueFromOldValue',
  valueToOldValue = 'valueToOldValue',
}

export interface DataProvider {
  x: number
  y: number
}

export interface ChartDescription {
  name: string
  label: string
  labelClassName?: string
  labelActiveClassName?: string
  labelOrder: number
  title?: string
  isAxis: boolean
  mc?: number
}

export interface TimeFrameButton {
  period: string
  frame: string
}
